export default class Logout {
	constructor(args) {
		this.tmContact = args?.get('tmcontact') ?? null;
		this.reason = args?.get('reason') ?? null;
		this.signature = args?.get('signature') ?? null;
   	this.init();
	}

	init() {
		// match login cookie
		let match = document.cookie.match(new RegExp('(^| )' + ( customData?.cookieContactId ?? null ) + '=([^;]+)'));
		match = null === match ? '' : match[2];
		let isLoggedIn = match ? true : false;

		if ( isLoggedIn && match == this.tmContact ) {
			// set cookies and redirect
			let expires = "";
			const date = new Date();
			date.setTime(date.getTime() + (-1));
			expires = "; expires=" + date.toUTCString();
			let cookieSetting = expires + "; path=/";

			document.cookie = customData?.cookieContactId + "=" + cookieSetting;
			document.cookie = customData?.cookieAuth + "=" + cookieSetting;

			let redirect = window.location.href;
			redirect = redirect.replace( window.location.search, '' );

			console.log('redirecting after logout: ' + redirect);
			window.location.href = redirect;
			// window.history.pushState( {}, document.title, redirect);
		}
	}
}
